import React__default from 'react';
import { useTheme, Box, Typography, Popover } from '@mui/material';
import DefaultIcon from '../../DefaultIcon/index.js';
import SanitizeHtml from '../../SanitizeHtml/index.js';

var CriteriaResult = function (_a) {
    var _b;
    var criteriaLabel = _a.criteriaLabel, isValid = _a.isValid, helper = _a.helper, additionalInformation = _a.additionalInformation, _c = _a.KIcon, KIcon = _c === void 0 ? DefaultIcon : _c, applyWarningColor = _a.applyWarningColor;
    var _d = React__default.useState(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var theme = useTheme();
    var handlePopoverOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handlePopoverClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    return (React__default.createElement(Box, { "data-testid": "CriteriaResult", sx: (_b = {
                width: "100%",
                background: function (theme) { return theme.palette.primary.light; },
                padding: function (theme) { return theme.spacing(1); },
                borderRadius: "4px",
                display: "flex",
                justifyContent: "space-between",
                gap: 1,
                marginBottom: function (theme) { return theme.spacing(2); }
            },
            _b["".concat(theme.breakpoints.down("sm"))] = {
                flexDirection: "column"
            },
            _b) },
        React__default.createElement(Box, { sx: { display: "flex", alignItems: "center", gap: "8px" } },
            React__default.createElement(Typography, null, criteriaLabel),
            helper && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Box, { "aria-owns": open ? "helper-popover" : undefined, "aria-haspopup": "true", onMouseEnter: handlePopoverOpen, onMouseLeave: handlePopoverClose },
                    React__default.createElement(KIcon, { className: "fa-regular fa-circle-info" })),
                React__default.createElement(Popover, { id: "helper-popover", sx: { pointerEvents: "none" }, open: open, anchorEl: anchorEl, anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                    }, transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                    }, onClose: handlePopoverClose, disableRestoreFocus: true, disableScrollLock: true },
                    React__default.createElement(Typography, { sx: { p: 1 } },
                        React__default.createElement(SanitizeHtml, { html: helper })))))),
        isValid === false && (React__default.createElement(Box, { sx: {
                display: "flex",
                gap: "8px",
                alignItems: "center",
                color: function (theme) {
                    return applyWarningColor ? theme.palette.warning.light : theme.palette.error.main;
                }
            } },
            React__default.createElement(Typography, { sx: {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: "300px"
                } }, additionalInformation),
            React__default.createElement(KIcon, { sx: { fontSize: "1.5em" }, className: "fa-solid fa-circle-xmark" }))),
        isValid && (React__default.createElement(Box, { sx: {
                display: "flex",
                gap: "8px",
                alignItems: "center",
                color: "#0b8a00"
            } },
            React__default.createElement(Typography, { title: additionalInformation, sx: {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: "300px"
                } }, additionalInformation),
            React__default.createElement(KIcon, { sx: { fontSize: "1.5em" }, className: "fa-solid fa-circle-check" })))));
};

export { CriteriaResult as default };
//# sourceMappingURL=index.js.map
